/** Formatea un timestamp del backend a `DD-MM-YYYY HH:mm` */
export const formatDateTime = (value: string | null | undefined): string => {
  if (!value) return "";

  const date: Date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  const pad = (input: number): string => String(input).padStart(2, "0");

  return `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()} ${pad(
    date.getHours()
  )}:${pad(date.getMinutes())}`;
};

/** Separa la fecha formateada en sus partes de día y hora para mostrarlas distinto */
export const formatDateParts = (
  value: string | null | undefined
): { date: string; time: string } => {
  const formatted: string = formatDateTime(value);
  if (!formatted) return { date: "", time: "" };

  const [date, time = ""] = formatted.split(" ");
  return { date, time };
};

/**
 * Formatea lo que se escribe en un filtro de fecha a `DD-MM-YYYY` en tiempo
 * real: descarta cualquier caracter no numérico, limita a 8 dígitos e inserta
 * los guiones automáticamente. El resultado nunca supera los 10 caracteres.
 */
export const formatDateInput = (value: string): string => {
  const digits: string = value.replace(/\D/g, "").slice(0, 8);
  const parts: string[] = [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4, 8)];

  return parts.filter(Boolean).join("-");
};

/** Formatea `569XXXXYYYY` como `+56 9 XXXX YYYY` para lectura */
export const formatPhone = (phone: string | null | undefined): string => {
  if (!phone) return "";
  if (!/^569\d{8}$/.test(phone)) return phone;

  return `+56 ${phone.slice(2, 3)} ${phone.slice(3, 7)} ${phone.slice(7)}`;
};

/** Iniciales para el avatar del usuario autenticado */
export const getInitials = (value: string | null | undefined): string => {
  if (!value) return "?";

  const [local] = value.split("@");
  const parts: string[] = local.split(/[._-]+/).filter(Boolean);

  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }

  return local.slice(0, 2).toUpperCase();
};

/**
 * Formatea un monto en dólares como `US$1,234.56`.
 * `fractionDigits` permite mostrar el precio unitario con más precisión
 * (ej. `US$0.053`) sin que el total redondeado parezca inconsistente.
 */
export const formatUsd = (amount: number, fractionDigits: number = 2): string =>
  `US$${amount.toLocaleString("en-US", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })}`;

/** Tamaño de archivo legible */
export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
